(function() {
	// globals
	window.EWO.Shell = {};
	EWO.Shell.menu = {};
	EWO.Shell.notificationTimer = false;
	EWO.Shell.environment = "";


	// module functions
	//render a select
	EWO.Shell.select = function(options) {
		/*
		example options:
		{
			name: 'typeId',
			id: 'typeId',
			options: [{desc: 'description 1', id: 1}, {desc: 'description 2', id: 2}, {desc: 'description 3', id: 3}],
			selectedId: 2,
			multiple: true/false
			allowEmpty: true/false,
			classes: 'some-extra-css classes to-add',
			selectedIfOnlyOne: true/false //if there is only one element in the list, select it,
			showNumber: true/false //if true show number example: 1 - NomeLista
		}
		*/

		if (options.options && options.options.length === 1 && options['selectedIfOnlyOne'] === true) {
			options.selectedId = [options.options[0].id];
		}

		if (!$.isArray(options.selectedId)) {
			options.selectedId = [options.selectedId];
		}
		
		//just to make sure it disappears
		$('.footerPresident').html('');
		$('.footerPresident').hide('');

		return ejs.rr('/app/shell/templates/controls/select.ejs', {options: options});
	};

	EWO.Shell.ellipsis = function(text, maxLength) {
		if (typeof maxLength === 'undefined') {
			maxLength = 9000; //a large number
		}
		if (typeof text === 'undefined') {
			return '';
		}
		if (text.length <= maxLength) {
			return text;
		}

		var xMaxFit = maxLength - 1;
		var xTruncateAt = text.lastIndexOf(' ', xMaxFit);
		if (xTruncateAt == -1 || xTruncateAt < maxLength / 2) {
			xTruncateAt = xMaxFit;
		}

		return text.substr(0, xTruncateAt) + '…';
	};

	EWO.Shell.newNotificationsLayout = function(notifications) {
		$('.js-notifications-nav').addClass(['bg-danger', 'text-white']);
		$('.js-notifications-badge').html($('.js-notification-new').length);

		if ($('.js-new-notifications-badge').length > 0) {
			$('.js-new-notifications-badge').html($('.js-notification-new').length);
		} else {
			$('.navbar-toggler-icon').after('<span class="badge badge-danger js-new-notifications-badge">' + $('.js-notification-new').length + '</span>');
		}
	};

	EWO.Shell.oldNotificationsLayout = function() {
		$('.js-notifications-nav').removeClass(['bg-danger', 'text-white']);

		$('.js-new-notifications-badge').remove();
	};

	EWO.Shell.notifications = function() {
		var handleNotifications = function() {
			$.get({
				url: EWO.config.apiUrlPrefix + '/notifications/currentuser',
				handled: true,
				noprogress: true
			})
			.done(function(notifications) {
				notifications = notifications.rows;

				if (notifications.length > 0) {
					ejs.preloadTemplate('/app/shell/templates/notifications.ejs', notifications)
					.done(function(templateUrl) {
						if ($('.js-notifications-dd').length > 0) {
							$('.js-notifications-dd').replaceWith(ejs.rr(templateUrl, {notifications: notifications}));
						} else {
							$('.js-navbar-profile').after(ejs.rr(templateUrl, {notifications: notifications}));
						}

						if ($('.js-notification-new').length > 0) {
							EWO.Shell.newNotificationsLayout();
						} else {
							EWO.Shell.oldNotificationsLayout();
						}
					});
				} else {
					$('.js-notifications-dd').remove();
				}
			});
		};
		if (EWO.Shell.notificationTimer) {
			handleNotifications();
		} else {
			EWO.Shell.notificationTimer = setInterval(handleNotifications, 10000);
			handleNotifications();
		}
	};

	EWO.Shell.renderShell = function() {
		document.title = i18next.t('EWO');

		//get environment
		if(EWO.config.environment != undefined && EWO.config.environment != ""){
			if(EWO.config.environment == "development"){
				EWO.Shell.environment = "DEV";
			}
			else if(EWO.config.environment == "test"){
				EWO.Shell.environment = "TEST";
			}
		}

		EWO.Symbols = {
			statusError: '<span class="status fa fa-times-circle-o"></span>', // circle with X
			statusSaved: '<span class="status fa fa-circle-o"></span>', // circle
			statusChecked: '<span class="status fa fa-check"></span>', // check
			statusPublished: '<span class="status fa fa-check"></span>', //cloud
			statusPreferred: '<span class="status">⭐</span>' //star
			//statusPreferred: '<span class="status" title="' + i18next.t('published') + '">&hearts; </span>' //heart
		};

		EWO.Symbols.getStatus = function(status) {
			if (status.status == 16) {
				return '<a class="js-unpublish" href="javascript:///" data-id="' + status.id + '" title="' + status.statusDesc + '">' + EWO.Symbols.statusChecked + '</a>';
			} else if (status.status == 2) {
				return '<a class="js-publish" href="javascript:///" data-id="' + status.id + '" title="' + status.statusDesc + '">' + EWO.Symbols.statusSaved + '</a>';
			} else if (status.status < 0) {
				return '<span class="text-danger" title="' + status.statusDesc + '">' + EWO.Symbols.statusError + '</span>';
			}
		};

		EWO.Symbols.getRegistriesStatus = function(status, canDoAction) {
			var action = "";
			if (status.status == 2) {
				if (canDoAction === false) {
				   action = " ";
				}
				else
				{
				   action = 'class="js-unpublish" ';
				}
				return '<a ' + action + ' href="javascript:///" data-id="' + status.id + '" title="' + i18next.t('Check') + '">' + EWO.Symbols.statusChecked + '</a>';
			} else if (status.status == 1) {
				if (canDoAction === false) {
					action = " ";
				 }
				 else
				 {
					action = 'class="js-publish" ';
				 }
				 return '<a ' + action + ' href="javascript:///" data-id="' + status.id + '" title="' + i18next.t('Uncheck') + '">' + EWO.Symbols.statusSaved + '</a>';
			} else if (status.status < 0) {
				return '<span class="text-danger" title="Error">' + EWO.Symbols.statusError + '</span>';
			}
		};

		EWO.Symbols.roleDesc = function(roleId){
			switch(roleId){
				case 1: return i18next.t('President');
				case 2: return i18next.t('Secretary');
				case 3: return i18next.t('Scrutineer');
				case 4: return i18next.t('VicePresident');
				case 5: return i18next.t('PresidentBis');
				case 6: return i18next.t('SecretaryBis');
				case 7: return i18next.t('ScrutineerBis');
				default: return i18next.t('No Role');
			}
		}

		var d = $.Deferred();

		$.when(
			ejs.preloadTemplate('/app/shell/templates/main.ejs'),
			ejs.preloadTemplate('/app/shell/templates/menu.ejs'),

			//templates that should always be ready go here:
			ejs.preloadTemplate('/app/shell/templates/controls/select.ejs')
		).done(function(templateUrl) {
			$.get(EWO.config.apiUrlPrefix + '/menu')
			.done(function(menu) {
				EWO.Shell.menu = menu;
				$('.js-main-content').html(ejs.rr(templateUrl, {menu: menu}));
				EWO.Shell.notifications(); //start notifications timer
				d.resolve();
			});
		});

		return d;
	};

	EWO.Shell.renderHomePage = function() {
		$('.js-page-container').html(ejs.rr('/app/shell/templates/home.ejs'));
	};

	EWO.Shell.render404 = function() {
		$('.js-page-container').html(ejs.rr('/app/shell/templates/404.ejs'));
	};

	EWO.Shell.doesHavePresident = function(filter, sectionId){
		$.get(EWO.config.apiUrlPrefix + '/people/sectionpresident/' + constituencyId + '/' + sectionId)
			.done(function(president) {
				if(president != undefined){
					return "<a class='dropdown-item js-getContactPresident' href='javascript:///' data-constituencyId="+filter.constituencyId +" data-sectionId="+sectionId +">" + i18next.t('Contact President') +"</a>";
				}
			});
	}

	// DA QUI
	const originalPushState = history.pushState;
	const originalReplaceState = history.replaceState;

	// Sovrascrivi pushState
	history.pushState = function() {
	originalPushState.apply(this, arguments);
	// Trigger del tuo evento personalizzato
	window.dispatchEvent(new Event('urlChanged'));
	};

	// Sovrascrivi replaceState
	history.replaceState = function() {
	originalReplaceState.apply(this, arguments);
	// Trigger del tuo evento personalizzato
	window.dispatchEvent(new Event('urlChanged'));
	};

	// Ascolta il tuo evento personalizzato
	window.addEventListener('urlChanged', function() {
	// console.log('URL cambiato:', window.location.href);
	extractElectionIdAndConstituencyId();
	});
	// esempio url http://127.0.0.1:8000/election/164/constituency/2273/candidates?listId=8529
	const extractElectionIdAndConstituencyId = () => {
		const url = window.location.href;
		// elction id sta dopo election
		const electionId = url && url.split('election/')[1] && url.split('election/')[1].split('/')[0];
		// constituency id sta dopo constituency
		const constituencyId = url && url.split('constituency/')[1] && url.split('constituency/')[1].split('/')[0];

		// console.log({ electionId, constituencyId,user:EWO.User });
		// inserisci in #navbar-operations 
		if(EWO.User.role == "ADMIN" && electionId != null && electionId != undefined){
			
		$('#navbar-operations').html(`
			<a class="nav-link dropdown-toggle" href="javascript:///" id="navbar-profile" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" id="admin-tools">${i18next.t('Administration')}</a>
			<div class="dropdown-menu" aria-labelledby="admin-tools">
				<li class="nav-item"><a class="dropdown-item" href="/elections/edit/${electionId}?returnUrl=${window.location.href}" target="">${i18next.t('Modify')}</a></li>
				<li class="nav-item"><a class="dropdown-item" href="/election/${electionId}/constituencies" target="">${i18next.t('Manage')}</a></li>
				<li class="nav-item"><a class="dropdown-item" href="/events/${electionId}?returnUrl=${window.location.href}" target="">${i18next.t('ConfigureEvents')}</a></li>
				<li class="dropdown-divider"></li>
				<li class="nav-item"><a class="dropdown-item" href="/election/${electionId}/toolSezioni" target="">${i18next.t('Gestione Sezioni')}</a></li>
				<li class="nav-item"><a class="dropdown-item" href="/election/${electionId}/toolUsers" target="">${i18next.t('Generazione Utenti')}</a></li>
				<li class="nav-item"><a class="dropdown-item" href="/election/${electionId}/toolSendCredentials" target="">${i18next.t('Invio Credenziali')}</a></li>
				</div>
				`);
			}else{
				$('#navbar-operations').html('');
			}
		return { electionId, constituencyId };
	}
	// FINO QUI



	// module events
	$(document).on('click', '#navbarSupportedContent a:not([data-toggle])', function() {
		$('#navbarSupportedContent').collapse('hide');
	});

	$(document).on('shown.bs.dropdown', '.js-notifications-dd', function(el) {
		clearInterval(EWO.Shell.notificationTimer);
		EWO.Shell.notificationTimer = false;
	});

	$(document).on('hide.bs.dropdown', '.js-notifications-dd', function(el) {
		EWO.Shell.notifications();
	});

	$(document).on('click', '.js-notification', function(ev) {
		var el = $(ev.currentTarget);
		var id = el.attr('data-id');
		var text = el.attr('data-text');
		PNotify.info({
			text: text,
			textTrusted: true
		});
		$.ajax({
			url: EWO.config.apiUrlPrefix + '/notifications/currentuser/' + id,
			type: 'PUT',
			data: {},
			contentType: 'application/json; charset=UTF-8'
		})
		.done(EWO.Shell.notifications);
	});

	//call/copy president phone number in footer element
	$(document).on('click', '.js-contactPresident', function(ev) {
		var el = $(ev.currentTarget);
		ev.preventDefault();
		var phone = el.attr('data-phone');

		//get element with phone number
		const node = document.getElementById("presidentPhoneNumber");

		//set selection
		if (window.getSelection) {
			const selection = window.getSelection();
			const range = document.createRange();
			range.selectNodeContents(node);
			selection.removeAllRanges();
			selection.addRange(range);
		}

		//wait and get selection then remove it
		setTimeout(
			function(){
				document.dispatchEvent(new KeyboardEvent('keydown', { key: 'F11' })); 
				const selection = window.getSelection();
				//selection.removeAllRanges();
			}, 100);

		navigator.clipboard.writeText(EWO.Shell.formatPhoneNumber(phone));

		PNotify.success(i18next.t('Number copied'));
	});

	// test if keypress works
	// 	document
	//   .addEventListener("keydown", e => {
	//     if(e.key === "F11") {
	//       e.preventDefault()
	// 	  console.log('premuto');
	//     }
	//   })

	//call/copy president phone number in list view
	$(document).on('click', '.js-getContactPresident', function(ev) {
		var el = $(ev.currentTarget);
		ev.preventDefault();
		ev.stopPropagation();
		var sectionId = el.attr('data-sectionId');
		var constituencyId = el.attr('data-constituencyId');

		$.get(EWO.config.apiUrlPrefix + '/people/sectionpresident/' + constituencyId + '/' + sectionId)
			.done(function(president) {
				if(president != undefined){

					//append element with phonenumber
					el.append("<span id='presidentPhoneNumber' type='text' style='z-index:0; position:absolute; color:rgba(0, 0, 0, 0.5);'>" + EWO.Shell.formatPhoneNumber(president.phone) + "</span>")
					
					//get it
					const node = document.getElementById("presidentPhoneNumber");

					//set selection
					if (window.getSelection) {
						const selection = window.getSelection();
						const range = document.createRange();
						range.selectNodeContents(node);
						selection.removeAllRanges();
						selection.addRange(range);
					}

					//ait and get selection then remove it, remove element, click out
					setTimeout(
						function(){
							document.dispatchEvent(new KeyboardEvent('keydown', { key: 'F11' })); 
							const selection = window.getSelection();
							selection.removeAllRanges();
							$("#presidentPhoneNumber").remove();
							$("body").trigger("click");
						}, 100);
					
					navigator.clipboard.writeText(EWO.Shell.formatPhoneNumber(president.phone));
					PNotify.success(i18next.t('Number copied'));
				}
				else
				{
					PNotify.error(i18next.t('President not set'));
				}
			});
	})

	EWO.Shell.formatPhoneNumber = function(phone) {

		if(phone != undefined)
		{
			phone = phone.replace(' ', '');

			if(phone.startsWith('+39')){
				var newStringPhoneNum = phone.replace('+39','');
				return '0' + newStringPhoneNum;
			} else if(phone.startsWith('0039')){
				var newStringPhoneNum = phone.replace('0039','');
				return '0' + newStringPhoneNum;
			} else if(phone.startsWith('+43') || phone.startsWith('+49') || phone.startsWith('+41')){
				var newStringPhoneNum = phone.replace('+','00');
				return '0' + newStringPhoneNum;
			} else if(phone.startsWith('0043') || phone.startsWith('0049') || phone.startsWith('0041')){
				return '0' + phone;
			} else if(phone.startsWith('0')){
				return phone;
			}

			return "0" + phone;
		}
		else
		{
			return "";
		}
	};

	// module startup

	//setup routing
	page('/', EWO.Shell.renderHomePage);
})();
